import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-envelope-send",
  "use": "foquz-icon-envelope-send-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" fill=\"none\" id=\"foquz-icon-envelope-send\"><path d=\"M10 13h6m-2-2l2 2-2 2M5 7l3 1 3-1m3 1V5a2 2 0 00-2-2H4a2 2 0 00-2 2v5a2 2 0 002 2h2\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol